import { trackMixpanel } from 'portal/store/mixpanel/actions'

const PROJECT_SWITCHER_OPEN = 'frontend_project_switcher_open'

export const trackSwitcherOpen = currentProject =>
  trackMixpanel(PROJECT_SWITCHER_OPEN, {
    current_project: currentProject
  })
